import { Chip, Stack, Typography } from '@mui/material';
type Props = {
  venueTypeName: string;
  venueSubTypeName?: string;
  venueName: string;
  venueAddress: string;
  onClick?: () => void;
};

export const VenueReviewCard: React.FC<Props> = ({
  venueTypeName,
  venueSubTypeName,
  venueName,
  venueAddress,
  onClick,
}) => {
  return (
    <Stack
      gap={1}
      sx={{
        minWidth: 275,
        width: '100%',
        border: '1px solid #D1D5DB',
        borderRadius: '8px',
        p: '12px 16px',
        cursor: 'pointer',
      }}
      component="div"
      onClick={onClick}
    >
      <Stack direction="row" gap={1} flexWrap="wrap">
        <Chip
          label={venueTypeName}
          sx={{
            color: 'text.placeholder',
            fontSize: 12,
            width: 'fit-content',
            bgcolor: '#F3F4F6',
            fontWeight: 500,
            height: 'auto',
            '& .MuiChip-label': {
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.2,
              padding: '4px 8px',
            },
          }}
        />
        {venueSubTypeName && (
          <Chip
            label={venueSubTypeName}
            sx={{
              color: 'text.placeholder',
              fontSize: 12,
              width: 'fit-content',
              bgcolor: '#F3F4F6',
              fontWeight: 500,
              height: 'auto',
              '& .MuiChip-label': {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: 1.2,
                padding: '4px 8px',
              },
            }}
          />
        )}
      </Stack>
      <Typography variant="h6" color="text.dark">
        {venueName}
      </Typography>
      <Typography variant="body2" color="text.placeholder">
        {venueAddress}
      </Typography>
    </Stack>
  );
};
